import { DocumentoEquipamiento } from "../../../types/DocumentoEquipamiento";
import { Equipamiento } from "../../../types/Equipamiento";

export const MENSAJE_NOMBRE_OBLIGATORIO = 'Debe completar el campo NOMBRE';
export const MENSAJE_TIPO_DOCUMENTO_OBLIGATORIO = 'Debe seleccionar un Tipo de Documento';
export const MENSAJE_RENOVABLE_SIN_DATOS = 'Debe indicar si tiene fecha editable o bien indicar el periodo de renovación del tipo de documento seleccionado';
export const MENSAJE_PERIODO_INVALIDO = 'La periodicidad debe ser un número entero de días mayor a cero';

export type FormEquipamientoErrors = {
    nombre?: string;
};

export type FormDocumentoErrors = {
    tipoDocumento?: string;
    periodo?: string;
};

export const validarEquipamiento = (equipamiento: Pick<Equipamiento, 'nombre'>): FormEquipamientoErrors => {
    const errors: FormEquipamientoErrors = {};
    if (!equipamiento.nombre || equipamiento.nombre.trim() === '') {
        errors.nombre = MENSAJE_NOMBRE_OBLIGATORIO;
    }
    return errors;
}

/**
 * Valida el modal "Agregar Tipo de Documento". Fecha editable y periodicidad son excluyentes y solo aplican a un
 * documento renovable: la pantalla ya deshabilita lo que no corresponde, esta validación cubre lo que falta.
 */
export const validarDocumento = (documento: DocumentoEquipamiento): FormDocumentoErrors => {
    const errors: FormDocumentoErrors = {};
    if (!documento.tipoDocumentoId) {
        errors.tipoDocumento = MENSAJE_TIPO_DOCUMENTO_OBLIGATORIO;
    }
    if (documento.renovable && !documento.fechaEditable) {
        if (!documento.periodo) {
            errors.periodo = MENSAJE_RENOVABLE_SIN_DATOS;
        } else if (!Number.isInteger(documento.periodo) || documento.periodo < 1) {
            errors.periodo = MENSAJE_PERIODO_INVALIDO;
        }
    }
    return errors;
}

/**
 * Cambio de un check del modal. Al desmarcar Renovable se limpian Fecha Editable y Periodicidad; al marcar
 * Fecha Editable se limpia la Periodicidad (son excluyentes).
 */
export const aplicarCambioCheck = (documento: DocumentoEquipamiento, campo: 'obligatorio' | 'renovable' | 'fechaEditable', valor: boolean): DocumentoEquipamiento => {
    const nuevo = { ...documento, [campo]: valor };
    if (campo === 'renovable' && !valor) {
        nuevo.fechaEditable = false;
        nuevo.periodo = 0;
    }
    if (campo === 'fechaEditable' && valor) {
        nuevo.periodo = 0;
    }
    return nuevo;
}
